import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "video",
  "use": "video-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"video\"><g data-name=\"Layer 2\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"13\"><circle cx=\"200\" cy=\"200\" r=\"113.54\" /><path d=\"M181.97 163.8v72.4l58.06-36.2-58.06-36.2z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol